export default function itemListDirective() {
  'ngInject';
  return {
    restrict: 'E',
    templateUrl: 'app/shared/directives/itemList/itemList.html',
    scope: {
      items: '=',
      columns: '=',
      itemTemplate: '@'
    },
    link: function ($scope, $element) {
      let listView = $element[0].querySelector('.item-list'),
        item;
      function listViewLength() {
        return listView.scrollWidth - listView.offsetWidth;
      }

      //Since the items are being rendered in from an ng-repeat we need to wait a scope digest for them to be in the dom.
      function end() {
        return $scope.moved >= listViewLength();
      }

      function move(direction = 1) {
        if (!item) {
          item = listView.querySelector('.item');
        }
        $scope.step = item.scrollWidth;//Get the current width of the item which could change at any time due to browser size changes.
        let amount = $scope.step * $scope.columns;
        if (direction < 0) {
          $scope.moved = Math.max(0, $scope.moved - amount);
        }
        else {
          $scope.moved += amount;
          $scope.moved = Math.min(listViewLength(), $scope.moved);
        }
        setOffset(listView, $scope.moved);
      }

      function setOffset(elem, amount) {
        TweenLite.to(elem, 1, {scrollLeft: amount, ease: Power4.easeOut});
      }

      $scope.moved = 0;
      $scope.move = move;
      $scope.end = end;
    }
  };
}



/** WEBPACK FOOTER **
 ** ./src/app/shared/directives/itemList/itemList.directive.js
 **/